import { render, staticRenderFns } from "./Berlin.vue?vue&type=template&id=20275fae&"
import script from "./Berlin.vue?vue&type=script&lang=js&"
export * from "./Berlin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports